import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=900ff9c4&"
import script from "./payFail.vue?vue&type=script&lang=js&"
export * from "./payFail.vue?vue&type=script&lang=js&"
import style0 from "./payFail.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports